import { render, staticRenderFns } from "./askQuestion.vue?vue&type=template&id=436a2f71&scoped=true"
import script from "./askQuestion.vue?vue&type=script&lang=js"
export * from "./askQuestion.vue?vue&type=script&lang=js"
import style0 from "./askQuestion.vue?vue&type=style&index=0&id=436a2f71&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.31_cache-loader@4.1.0_webpack@4.47.0__css-load_96f0868f9f114531bdcfa48c322cb453/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "436a2f71",
  null
  
)

export default component.exports